<template>
  <v-flex xs12 class="text-xs-center" v-if="$store.state.drivers.loadingDrivers">
    <v-progress-circular indeterminate :color="$store.state.global.pages[$route.name].color"></v-progress-circular>
  </v-flex>
  <transition name="fadeToggle" mode="out-in" v-else>
    <v-flex xs12 v-if="listView">
      <v-card>
        <v-data-table
          :items="filteredDrivers"
          :headers="headers"
          :rows-per-page-items="itemsPerPageOptions"
        >
          <template slot="items" slot-scope="props">
            <table-row :headers="headers" :row="props.item" parent="Driver" :key="props.item.id"></table-row>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

    <transition-group name="data-list" tag="layout-no-padding" v-else>
      <v-flex
        xs12
        sm6
        md4
        xl3
        v-for="(driver,i) in filteredDrivers.slice(0, 16)"
        :key="driver.id"
        class="data-list-item"
      >
        <driver-card :driver="driver" :index="i"></driver-card>
      </v-flex>
    </transition-group>
  </transition>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import DriverService from '@/services/requests/driverService'
import DriverCard from '@/components/drivers/driverCard'
import TableRow from '@/components/ui/masterFileTableRow'
export default {
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'name'
        },
        {
          text: 'Contact Email',
          align: 'left',
          value: 'contactEmail'
        },
        {
          text: 'ContactPhone',
          align: 'left',
          value: 'contactPhone'
        },
        {
          text: 'Contractor',
          align: 'right',
          value: 'contractor.name'
        },
        {
          text: 'Compliance Resources',
          align: 'right',
          value: 'complianceCount'
        },
        {
          text: 'Actions',
          align: 'center',
          sortable: false
        }
      ]
    }
  },
  computed: {
    sortBy: Store.getSet({ store: 'drivers', prop: 'sortBy' }),
    filterBy: Store.getSet({ store: 'drivers', prop: 'filterBy' }),
    drivers: Store.getSet({ store: 'drivers', prop: 'drivers' }),
    listView: Store.getSet({ store: 'drivers', prop: 'listView' }),
    contractor: Store.getSet({ store: 'drivers', prop: 'contractor' }),
    showInactive: Store.getSet({ store: 'drivers', prop: 'showInactive' }),
    selectedRecordType: Store.getSet({
      store: 'drivers',
      prop: 'selectedRecordType'
    }),
    contractorFilteredDrivers() {
      if (!!this.contractor) {
        return this.drivers.filter(driver => {
          return driver.contractorId == this.contractor
        })
      } else {
        return this.drivers
      }
    },
    sortedDrivers() {
      if (this.sortBy) {
        var path = this.sortBy
        return this.contractorFilteredDrivers.sort((a, b) => {
          //if(a[property] < b[property])
          if (this.getObjectPath(path, a) < this.getObjectPath(path, b)) {
            if (path == 'updatedAt') {
              return 1
            }
            return -1
          } else {
            if (path == 'updatedAt') {
              return -1
            }
            return 1
          }
        })
      } else {
        return this.contractorFilteredDrivers
      }
    },
    filteredDrivers() {
      return this.sortedDrivers.filter(driver => {
        const searchMatch =
          driver.name.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1
        if (this.selectedRecordType === 'Inactive')
          return searchMatch && (!driver.active || !driver.contractor.active)
        else if (this.selectedRecordType === 'Request')
          return searchMatch && driver.request
        else
          return (
            searchMatch &&
            driver.active &&
            driver.contractor.active &&
            !driver.request
          )
        // return (driver.name.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1 &&
        // driver.active != this.showInactive &&
        // driver.contractor.active != this.showInactive)
      })
      //return this.sortedDrivers;
    }
  },
  components: {
    DriverCard,
    TableRow
  }
}
</script>

<style scoped>
</style>
